<route lang="json">
{
  "name": "ai_assistant-show-public"
}
</route>

<script setup lang="ts">
import { useConversationQueries } from "@/composables/ai-chat/useConversationQueries";

const { t } = useI18n();
const router = useRouter();
const route = useRoute("ai_assistant-show-public");

const { useCreateMutation } = useConversationQueries();

onMounted(async () => {
  const { mutateAsync } = useCreateMutation();
  const data = await mutateAsync({
    name: t("aiChat.labels.newConversation"),
    aiAssistantId: route.params.id,
  });

  router.replace({
    name: "ai-assistant-public-chat",
    params: {
      id: route.params.id,
      conversationId: data.id,
    },
    query: {
      token: route.query.token as string,
      public_token: route.query.public_token as string,
    },
  });
});
</script>

<template>
  <router-view />
</template>
